<template>
  <b-container fluid>
    <div class="overflow-auto" v-if="!loader">


        <b-form-group class="mb-0 filter">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>


      <b-table
        id="my-table"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :striped="true"
        :bordered="true"
        :hover="false"
        :dark="false"
        small
        :filter="filter"
      >
        <template slot="notify" slot-scope="row">
          <div v-if="row.item.status == 'open'">
            <button class="table-btn" size="sm" @click="sendNotification(row.item)" >
              <span>{{ row.item.notify }}</span>
            </button>
          </div>

          <span v-else>{{ row.item.notify }}</span>
        </template>

        <template slot="options" slot-scope="row">
          <!-- Close -->
          <button v-if="hasCloseButton" class="table-btn" size="sm" @click="closeOrderModalFun(row.item)">
              <span>Close</span>
          </button>

          <!-- Edit -->
          <button v-if="hasEditButton" class="table-btn" size="sm" @click="toggleEditOrder(row.item)">
              <span>Edit</span>
          </button>

          <!-- Delete -->
          <button v-if="hasDeleteButton" class="table-btn" size="sm" @click="deleteOrderModalFun(row.item)">
              <span>Delete</span>
          </button>

          <!-- Edit Customer -->
          <button v-if="hasEditCustomerButton" class="table-btn" size="sm" @click="editCustomerSetup(row.item)">
              <span>Edit</span>
          </button>

          <!-- Delete Customer -->
          <button v-if="hasDeleteCustomerButton" class="table-btn" size="sm" @click="deleteCustomerSetup(row.item)">
              <span>Delete</span>
          </button>

          <!--_______________________________________ DELETE ORDER MODAL  ______________________________________-->
          <alert-dialog v-if="deleteOrderModal == true" class="alert-dialog" message="Are you sure you want to delete this order?">
            <b-btn class="cancel-update" @click="deleteOrderModal = false">X</b-btn>
            <b-btn class="submit-btn" slot="successBtn" @click="deleteOrder()">Delete</b-btn>
            <b-btn class="cancel-btn" slot="cancelBtn" @click="deleteOrderModal = false">Cancel</b-btn>
          </alert-dialog>

          <!--_______________________________________ CLOSE ORDER MODAL  ______________________________________-->
          <alert-dialog v-if="closeOrderModal == true" class="alert-dialog" message="Are you sure you want to close this order?">
            <b-btn class="cancel-update" @click="closeOrderModal = false">X</b-btn>
            <b-btn class="submit-btn" slot="successBtn" @click="closeOrder()">Close</b-btn>
            <b-btn class="cancel-btn" slot="cancelBtn" @click="closeOrderModal = false">Cancel</b-btn>
          </alert-dialog>

        </template>

      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="right"
      ></b-pagination>

      <!--_____________________________________ Edit Order Form ____________________________________-->
          <alert-dialog v-if="editOrder == true" class="alert-dialog" message="Edit Order">
              <b-btn class="cancel-update" @click="editOrder = false">X</b-btn>
              <div class="mt-5" slot="formInput">
                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Customer:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newName" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Phone:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" placeholder="(xxx)xxx xxxx" v-model="newPhone" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row v-if="tagKeys.length > 0" class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="tags">Tags <span style="font-size:12px;">(optional)</span> </label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-select id="tags" size="sm" :options="tagKeys" v-model="newTag"></b-form-select>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Notes:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-textarea id="note" placeholder="optional" v-model="newNote"></b-form-textarea>
                    </b-col>
                    <b-form-text class="left-align-text" style="transform: translateX(-80px);">Notes 35 characters max</b-form-text>
                </b-row>

              </div>
              <b-btn :disabled="!noteState" class="submit-btn" slot="successBtn" @click="submitEditOrder">Edit</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="editOrder = false">Cancel</b-btn>
          </alert-dialog>

      <!--__________________________________ Edit Customer Form __________________________________ -->
          <alert-dialog v-if="editCustomer == true" class="alert-dialog" message="Edit Customer">
              <b-btn class="cancel-update" @click="editCustomer = false">X</b-btn>
              <div class="mt-5" slot="formInput">
                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Customer:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newCustomerName" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">Phone:</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="tag" type="text" v-model="newCustomerPhone" ></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="form-row marketing-checkbox" align-h="center" align-v="center">
                  <!-- <b-form-checkbox
                    id="checkbox-1"
                    v-model="marketingOpt"
                    name="checkbox-1"
                    :value="true"
                    :unchecked-value="false"
                    >
                    Opt-into marketing text messages
                  </b-form-checkbox> -->

                  <b-form-group class="mt-3" label="Opt-into marketing text messages">
                    <b-form-radio-group
                      id="radio-group-1"
                      v-model="marketingOpt"
                      :options="marketingOptions"
                      name="radio-options"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-row>

              </div>
              <b-btn class="submit-btn" slot="successBtn" @click="submitEditCustomer">Edit</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="editCustomer = false">Cancel</b-btn>
          </alert-dialog>

          <!--_______________________________________ DELETE Customer form  ______________________________________-->
          <alert-dialog v-if="deleteCustomer == true" class="alert-dialog" message="Are you sure you want to delete this customer?">
            <b-btn class="cancel-update" @click="deleteCustomer = false">X</b-btn>
            <b-btn class="submit-btn" slot="successBtn" @click="deleteThisCustomer">Delete</b-btn>
            <b-btn class="cancel-btn" slot="cancelBtn" @click="deleteCustomer = false">Cancel</b-btn>
          </alert-dialog>




    </div>

    <div v-else>
      <Loader/>
    </div>

    <!-- <div v-if="editOrder" class="edit-order" >
      <edit-order :submitEdit="submitEditOrder" :cancelEdit="cancelEditOrder" :previousNotes="notes" :editOrderItem="editItem"></edit-order>
    </div> -->




  </b-container>
</template>

<script>
var moment = require('moment');
import AlertDialog from "../components/alert-dialog/AlertDialog"
import EditOrder from "../components/table/open/EditOrder"
import Loader from "../components/Loader"
import firebase from 'firebase'
import axios from 'axios'
export default {
  components: {
    Loader,
    EditOrder,
    AlertDialog
  },
  props: {
    items: Array,
    fields: Array,
    hasDeleteButton: {
      default: false,
      type: Boolean
    },
    hasEditButton: {
      default: false,
      type: Boolean
    },
    hasCloseButton: {
      default: false,
      type: Boolean
    },
    hasEditCustomerButton: {
      default: false,
      type: Boolean
    },
    hasDeleteCustomerButton: {
      default: false,
      type: Boolean
    }
},
  data() {
    return {
      perPage: 20,
      currentPage: 1,
      loader: false,
      sendNotificationApi: 'https://us-central1-readytextme.cloudfunctions.net/orderNotification',
      closeOrderApi: 'https://us-central1-readytextme.cloudfunctions.net/closeOrder',
      deleteOrderApi: 'https://us-central1-readytextme.cloudfunctions.net/deleteOrder',
      editOrderApi: 'https://us-central1-readytextme.cloudfunctions.net/editOrder',
      editCustomerApi: 'https://us-central1-readytextme.cloudfunctions.net/editCustomer',
      deleteCustomerApi: 'https://us-central1-readytextme.cloudfunctions.net/deleteCustomer',
      editOrder: false,
      notes: '',
      editItem: null,
      deleteItem: null,
      customerEditItem: null,
      filter: null,
      moment: moment,
      newName: '',
      newTag: '',
      newNote: '',
      newPhone: '',
      newCustomerName: '',
      newCustomerPhone: '',
      tagKeys: [],
      editCustomer: false,
      marketingOpt: false,
      deleteCustomer: false,
      marketingOptions: [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
      ],
      textsFinished: false,
      deleteOrderModal: false,
      closeOrderModal: false,
      rowItem: null,
      rowPhone: '',
      rowName: '',
      rowOpt: false
    }
  },
  watch: {

  },
  async created() {
    const userDoc = await firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async (doc) => {
        const business = doc.data().business;
        this.business = business;
        const textsFinishedBool = doc.data().planTextsFinished;

        if (textsFinishedBool == 1) {
          this.textsFinished = true;
        } else {
          this.textsFinished = false;
        }

        const businessSnapshot = await firebase.firestore().collection('businesses').doc(business).onSnapshot(async (docc) => {
          this.tagKeys =  Object.keys(docc.data().tags);
        })
    });


  },
  methods: {

    async sendNotification(item) {

            if (this.textsFinished) {
              this.$router.push({path: '/texts-finished'});
              return;
            }
            console.log('Sending notification');

            const timeSent = this.moment().format('DD-MM-YYYY hh:mm:ss A');
            // console.log(item);
            // send phone to api
            const obj = {
                 'business': item.business,
                 'customer': item.customer,
                 'phone': item.phone_number,
                 'uid': firebase.auth().currentUser.uid,
                 'startTime': item.startTime,
                 'sentTime': timeSent
            }

            // console.log(obj);

            try {
                this.loader = true;
                await axios.post(
                    this.sendNotificationApi,
                    obj,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }
                )
                this.loader = false;
                // if (response.status == '200') {
                // }
                console.log('notification sent');
            } catch (error) {
                console.log(error);
                this.loader = false;
            }
        },
    async closeOrder () {
      console.log('closing order');

      const closedTime = this.moment().format('DD-MM-YYYY hh:mm:ss A');

      const closItem = this.rowItem;

      const obj = {
        'business': closItem.business,
        // 'customer': item.customer,
        'phone': closItem.phone_number,
        // 'status': 'closed',
        'startTime': closItem.startTime,
        'closedTime': closedTime,
        'tags': [closItem.tags]
      }

      // console.log(obj);

      try {
        this.loader = true;
        await axios.post(
        this.closeOrderApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.loader = false;
        this.closeOrderModal = false;
        console.log('order closed');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }

    },

    deleteOrderModalFun(item) {
      this.deleteOrderModal = true;
      this.rowItem = item;
      // console.log(this.rowItem);
    },

    closeOrderModalFun(item) {
      this.closeOrderModal = true;
      this.rowItem = item;
      // console.log(this.rowItem);
    },

    async deleteOrder () {
      console.log('deleting order');

      const delItem = this.rowItem;

      const obj = {
        'business': delItem.business,
        'phone': delItem.phone_number,
        'startTime': delItem.startTime
      }

      // console.log(obj);

      try {
        this.loader = true;
        await axios.post(
        this.deleteOrderApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.loader = false;
        this.deleteOrderModal = false;
        console.log('order deleted');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }

    },

    toggleEditOrder (item) {
      this.editOrder = true;
      this.notes = item.notes;
      this.editItem = item;
      this.newName = item.customer;
      this.newPhone = item.phone_number;
      this.newTag = item.tags;
      this.newNote = item.note;
    },

    deleteCustomerSetup (item) {
      this.deleteCustomer = true;
      this.deleteItem = item;
    },

    editCustomerSetup (item) {
      this.editCustomer = true;
      this.customerEditItem = item;
      this.newCustomerName = item.customer;
      this.newCustomerPhone = item.phone_number;
      this.marketingOpt = item.marketingOpt;
    },

    //  EDIT ORDER _________________
    async submitEditOrder () {
      console.log('editing order');

      const item = this.editItem;

      const obj = {
        'business': item.business,
        'phone': item.phone_number,
        'startTime': item.startTime,
        'customer': this.newName,
        'tag': this.newTag,
        'newPhone': this.newPhone,
        'notes': this.newNote,
        'oldTag': item.tags
      }

      // console.log(obj);

      try {
        this.loader = true;
        await axios.post(
        this.editOrderApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.editOrder = false;
        this.loader = false;
        console.log('order edited');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }
    },

    // EDIT CUSTOMER _______________
    async submitEditCustomer () {
      console.log('editing customer');

      const item = this.customerEditItem;

      const obj = {
        'business': this.business,
        'phone': item.phone_number,
        'customer': this.newCustomerName,
        'newPhone': this.newCustomerPhone,
        'marketingOpt': this.marketingOpt
      }

      // console.log(obj);

      try {
        this.loader = true;
        await axios.post(
        this.editCustomerApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.editCustomer = false
        this.loader = false;
        console.log('customer edited');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }
    },

    async deleteThisCustomer () {
      console.log('deleting customer');

      const item = this.deleteItem;

      const obj = {
        'business': this.business,
        'phone': item.phone_number,
        'customer': item.customer
      }

      // console.log(obj);

      try {
        this.loader = true;
        await axios.post(
        this.deleteCustomerApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.deleteCustomer = false
        this.loader = false;
        console.log('customer deleted');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }
    },

    cancelEditOrder () {
      this.editOrder = false
    }
  },
  computed: {
    rows() {
      return this.items.length
    },

    noteState () {
      return this.newNote.length == 0 || this.newNote.length < 36 ? true : false
    },
  }
}
</script>

<style scoped>
.table-btn {
    border: 0px;
    background-color: #ffffff00;
    color: #DA2a2a;
    /* color: #2f8ce2; */
}

.table-btn:hover {
    text-decoration: underline;
}

.edit-order {
  position: absolute;
  width: 400px;
  height: 330px;
  z-index: 100;
  padding-top: 70px;
  /* top: 0; */
  bottom: 30%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #e7e7e7;
  border-radius: 5px;
  transition: all 0.8s ease;
}

.filter {
  /* position: absolute; */
  /* left: 0; */
  width: 300px;
  padding-bottom: 20px;
}

.alert-dialog {
  position: fixed;
  border: 1px solid #929292;
  border-radius: 5px;
  padding: 20px 20px;
  background-color: #ececec;
  width: 700px;
  z-index: 3;
  top: 30%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
}

.left-align-text {
  text-align: start;
}

@media (max-width: 600px) {
    .alert-dialog {
        width: 380px;
    }
}
</style>
